@if (active) {
  <div class="spinner-container" [class.spinner-overlay]="overlay">
    @if (showContent) {
      <ng-content></ng-content>
    }
    <mat-progress-spinner
      [diameter]="diameter"
      [strokeWidth]="strokeWidth"
      [color]="colour"
      class="spinner"
      [ngClass]="{ content: showContent }"
      mode="indeterminate"
    ></mat-progress-spinner>
  </div>
}
